import { useTranslation } from 'react-i18next';

import { SingleAssignment } from 'shared/api/assignment-service';
import { StreamCard } from 'shared/ui/stream-card';
import { getClassroomDashboardLink } from 'shared/lib/utils';
import { CardEventHandlers } from 'shared/api/event-service';

type Props = {
  classLabel: string;
  assignment: SingleAssignment;
  eventHandlers: CardEventHandlers;
};

export const AssignmentCard = ({
  classLabel,
  assignment,
  eventHandlers,
}: Props) => {
  const { t } = useTranslation();
  const classroomDashboardLink = assignment.content.hasWorksheet
    ? getClassroomDashboardLink(assignment.content, assignment.classBks[0])
    : null;

  return (
    <StreamCard
      assignment={assignment}
      classLabel={classLabel}
      content={assignment.content}
      caption={t('You assigned')}
      eventHandlers={eventHandlers}
      startDate={assignment.startDate ?? assignment.createdDate}
      dueDate={assignment.dueDate}
      viewWorkButtonUrl={classroomDashboardLink}
    />
  );
};
